var Cookie = {
  set: function (name, value, days) {
    var expires = "; expires=Fri, 31 Dec 9999 23:59:59 GMT";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    } else if (days === null) {
      expires = ""
    }
    var value = name + "=" + (value || "")  + expires + "; path=/";
    document.cookie = value;
    console.info(value)
  },
  get: function(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  },
  delete: function(name) {   
    document.cookie = name+'=; Max-Age=-99999999;';  
  }
}

module.exports = Cookie

    